export default {
    'name': 'telegram',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path d=\'M20 4.60223L16.9946 20.2923C16.9946 20.2923 16.5741 21.3801 15.4189 20.8584L8.48458 15.3526L8.45242 15.3364C9.38909 14.4654 16.6524 7.70266 16.9698 7.39612C17.4613 6.92136 17.1562 6.63873 16.5856 6.99736L5.85679 14.053L1.71764 12.6108C1.71764 12.6108 1.06626 12.3708 1.00359 11.8491C0.940104 11.3265 1.73908 11.0439 1.73908 11.0439L18.6131 4.18895C18.6131 4.18895 20 3.55793 20 4.60223Z\' fill=\'#026958\'/>'
}
